module.exports = __webpack_public_path__ + "static/img/aboutUs.219175ab.png";